export enum SettingsActionTypes {
  TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN',
  TOGGLE_ICON_MODE = 'TOGGLE_ICON_MODE',
  TOGGLE_SHEEN = 'TOGGLE_SHEEN',
  TOGGLE_SHEEN_HOVER = 'TOGGLE_SHEEN_HOVER',
}
